import { ReactNode } from 'react'

import { Box, Link, Typography } from '@mui/material'
import isString from 'lodash/isString'

import { MBreadcrumbs } from 'components/@material-extend'
import { MBreadcrumbsProps } from 'components/@material-extend/MBreadcrumbs'

interface HeaderBreadcrumbsProps extends MBreadcrumbsProps {
  action?: ReactNode
  heading?: string
  moreLink?: string | string[]
}

const HeaderBreadcrumbs = ({
  links,
  action,
  heading,
  moreLink = '' || [],
  sx,
}: HeaderBreadcrumbsProps) => {
  return (
    <Box sx={{ ...sx }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ flexGrow: 1 }}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h4">{heading}</Typography>
          </Box>
          <MBreadcrumbs links={links} />
        </Box>

        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Box>

      <Box sx={{ mt: 2 }}>
        {isString(moreLink) ? (
          <Link href={moreLink} target="_blank" variant="body2">
            {moreLink}
          </Link>
        ) : (
          moreLink.map((href) => (
            <Link
              noWrap
              key={href}
              href={href}
              variant="body2"
              target="_blank"
              sx={{ display: 'table' }}
            >
              {href}
            </Link>
          ))
        )}
      </Box>
    </Box>
  )
}

export default HeaderBreadcrumbs
